(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var audio = document.querySelector('[data-tc-intro-audio]');
    var hearButtons = document.querySelectorAll('[data-tc-hear]');
    if (!hearButtons.length) return;

    function syncHearState(playing) {
      hearButtons.forEach(function (btn) {
        var label = btn.getAttribute(playing ? 'data-label-pause' : 'data-label-play');
        if (label) btn.setAttribute('aria-label', label);
        btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      });
    }

    hearButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!audio) return;
        if (audio.paused) {
          var playPromise = audio.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise
              .then(function () {
                syncHearState(true);
              })
              .catch(function () {});
          } else {
            syncHearState(true);
          }
        } else {
          audio.pause();
          syncHearState(false);
        }
      });
    });

    if (audio) {
      audio.addEventListener('ended', function () {
        syncHearState(false);
      });
      audio.addEventListener('pause', function () {
        if (audio.ended || audio.paused) syncHearState(false);
      });
    }
  });
})();
